import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import { Card, Table, Modal } from 'antd';

import moment from 'moment';

import './DTCsCard.css';
import { commonStore } from '../../../../../stores';

const serviceLevelsWithLimitedFeatures = ['light-a'];

@inject('translationsStore', 'commonStore')
@observer
export default class DTCsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.columns = (translate, longDateFormat, locale) => [
      {
        title: translate('carView.DTCsCard.table.columns.code'),
        dataIndex: 'code',
        width: '80px',
        className: 'code',
        render: (text, record) => {
          let style = { textDecoration: 'underline' };
          return <span className={record.severity === 'red' ? 'red' : 'orange'}><a style={style} className={record.severity === 'red' ? 'red' : 'orange'} onClick={e => {
            e.stopPropagation();
            this.showExtendedDTCs(record);
          }}>{text}</a></span>;
        }
      },
      {
        title: translate('carView.DTCsCard.table.columns.description'),
        dataIndex: 'description',
        render: (text, record) => (record.dtcTranslations.find(translation => translation.language === locale) || {}).description || record.description
      },
      {
        title: translate('carView.DTCsCard.table.columns.initialRecordedAt'),
        dataIndex: 'initialRecordedAt',
        render: text => <div>{moment(text).format(longDateFormat.L)}</div>,
        width: '100px'
      },
      {
        title: translate('carView.DTCsCard.table.columns.initialOdometer'),
        align: 'center',
        dataIndex: 'initialOdometer',
        width: '70px'
      },
      {
        title: translate('carView.DTCsCard.table.columns.km'),
        align: 'center',
        dataIndex: 'km',
        width: '70px'
      }
    ];
    this.showExtendedDTCs = record => {
      const { translationsStore } = this.props;

      return (Modal.info({
        icon: <div />,
        title: <span class="bold">{translationsStore.translate('carView.DTCsCard.extendedDescription')}</span>,
        width: 720,
        content: (
          <div>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.subcategoryDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).subcategoryDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.warningDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).warningDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.recommendationDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).recommendationDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.causeDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).causeDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.effectDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).effectDescription|| '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.classification')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).classification || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
          </div>
        ),
        onOk() {},
      }));
    };
  }

  render() {
    const { translationsStore } = this.props;

    return (
      <Card className="DTCsCard" style={this.props.style} id="DTCsCard">
        <div className="header">
          <div>{translationsStore.translate('carView.DTCsCard.title')}</div>
        </div>
        <div className="container" style={{position:"relative"}}>
          {serviceLevelsWithLimitedFeatures.includes(this.props.serviceLevel) && <div className={"CoverDiv"}/>}
          <Table
            rowClassName={record => (record.severity === 'red' ? 'red' : 'orange')}
            pagination={false}
            columns={this.columns(translationsStore.translate.bind(translationsStore), commonStore.longDateFormat, translationsStore.locale)}
            dataSource={this.props.dtcs}
            rowKey={record => record.id}
          />
          {!!this.props.otherdtcs && this.props.otherdtcs.length > 0 && (
            <div
              onClick={() => this.setState({ showothers: true })}
              style={{
                marginTop: '10px',
                cursor: 'pointer',
                textDecoration: 'underline',
                fontWeight: 'bold'
              }}
            >
              {this.props.otherdtcs.length} {translationsStore.translate('carView.DTCsCard.otherdtcs.message')}
            </div>
          )}
        </div>
        <Modal
          title={translationsStore.translate('carView.DTCsCard.otherdtcs.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.showothers}
          getContainer={() => document.getElementById('DTCsCard')}
          footer={null}
          onCancel={() => this.setState({ showothers: false })}
          centered={true}
        >
          <Table
            rowClassName={record => (record.severity === 'red' ? 'red' : 'orange')}
            pagination={false}
            columns={this.columns(translationsStore.translate.bind(translationsStore), commonStore.longDateFormat, translationsStore.locale)}
            dataSource={this.props.otherdtcs}
            rowKey={record => record.id}
          />
        </Modal>
      </Card>
    );
  }
}
